export const ROLES = {
  student: { value: 1, title: 'Обучающийся' },
  teacher: { value: 2, title: 'Преподаватель' },
  organization: { value: 3, title: 'Организация' },
  user: { value: 4, title: 'Пользователь' },
  listener: { value: 5, title: 'Слушатель' },
  operator: { value: 6, title: 'Оператор' },
  department: { value: 7, title: 'Департамент' },
  admin: { value: 100, title: 'Администратор' },
};

export const ACCOUNT_TYPE = {
  organization: 3,
  student: 5,
  teacher: 2,
};
export const ACCOUNT_TYPE_DATA = {
  [ACCOUNT_TYPE.organization]: {
    text: 'Я организация',
    icon: 'mdi-account-details-outline',
  },
  [ACCOUNT_TYPE.student]: {
    text: 'Я обучающийся',
    icon: 'mdi-certificate-outline',
  },
  [ACCOUNT_TYPE.teacher]: {
    text: 'Я учитель',
    icon: 'mdi-account-outline',
  },
};

export const TWO_STEPS_AUTH_ROLES = [
  ROLES.organization.value,
  ROLES.operator.value,
  ROLES.department.value,
];

export function getRoleName(roleId) {
  const role = Object.values(ROLES).find((r) => r.value === roleId);
  if (role) return role.title;
  return ROLES.user.title;
}

export default { ROLES, ACCOUNT_TYPE, ACCOUNT_TYPE_DATA };
